import { QueryClient } from "@tanstack/react-query";
import React from "react";
import { WorkplaceRequestsRef } from "@/types/workplace-requests";

export const invalidateReservationQueries = async (
  queryClient: QueryClient
) => {
  await queryClient.invalidateQueries({ queryKey: ["schedules"] });
  await queryClient.invalidateQueries({ queryKey: ["myAgenda"], exact: false });
  await queryClient.invalidateQueries({
    queryKey: ["organizations.schedulable"]
  });
  await queryClient.invalidateQueries({ queryKey: ["tableOverview"] });
  await queryClient.invalidateQueries({
    queryKey: ["organizations.questionnaire"]
  });
};

export const createWorkplaceRequestFromRef = async (
  wpRequestsRef: React.RefObject<WorkplaceRequestsRef>,
  scheduleId: string,
  ownerUserId: string
) => {
  if (wpRequestsRef?.current) {
    try {
      const result = await wpRequestsRef.current.submitWorkplaceRequests({
        scheduleId,
        ownerUserId
      });
      if (!result.success) {
        // Log error but don't block the reservation success
        // TODO: Handle workplace request errors appropriately
      }
    } catch (error) {
      // Log error but don't block the reservation success
      // TODO: Handle workplace request errors appropriately
    }
  }
};
